// Copyright (c) Ensho Health, 2021 to present

import httpClient from '../api/client-http.js';
import { workflowClient, privateClient } from '../api/client-gql.js';
import { oktaClient } from '../../okta.js';

import actions from './index.js';

const PREFIX = 'app';
export const ACTION_TYPES = {
  INIT_COMPLETE: `${PREFIX}-INIT_COMPLETE`,
  ERROR: `${PREFIX}-ERROR`,
  LOADING: `${PREFIX}-LOADING`
};

export function init() {
  return async (dispatch) => {
    try {
      dispatch({ type: ACTION_TYPES.LOADING });
      await dispatch(setApiHeaders());
      await dispatch(actions.user.fetch());
      await dispatch(actions.encryption.init());
      dispatch({ type: ACTION_TYPES.INIT_COMPLETE });
    } catch (error) {
      console.error(error.message);
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}

export function setApiHeaders() {
  return async (dispatch) => {
    try {
      oktaClient.authStateManager.updateAuthState();
      const authState = oktaClient.authStateManager.getAuthState();
      const token = authState?.accessToken?.accessToken;
      if (token) {
        httpClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        workflowClient.setHeader('Authorization', `Bearer ${token}`);
        privateClient.setHeader('Authorization', `Bearer ${token}`);
      }
    } catch (error) {
      console.error(error.message);
      dispatch({ type: ACTION_TYPES.ERROR, payload: error.message });
    }
  };
}
